import "./Landing.scss";
import { motion } from "framer-motion";

const Landing = ({ img, title, from, page }) => {
  return (
    <section className="landing p_t p_b">
      <div className="content_wrap p_t p_b">
        <motion.h1
          initial={{ translateY: 32, opacity: 0 }}
          whileInView={{ translateY: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          {title}
        </motion.h1>
        {from && page && (
          <div className="link_wrap">
            <motion.p
              initial={{ translateY: 32, opacity: 0 }}
              whileInView={{ translateY: 0, opacity: 1 }}
              transition={{ duration: 0.6, ease: "easeInOut", delay: 0.15 }}
              viewport={{ once: true }}
              className="t_16"
            >
              {from} : {page}
            </motion.p>
          </div>
        )}
      </div>
    </section>
  );
};
export default Landing;
